import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, CAN_CREATE_PROJECT_LAND_USES, CAN_EDIT_PROJECT_LAND_USES} from "../../../lib/permissions";

const create = {
    table: 'project_land_uses',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Project Land Use',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'}
        }
    }
}

const update = {
    table: 'project_land_uses',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Project Land Use',
        type: 'object',
        required: ['description'],
        properties: {
            project_land_use_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'}
        }
    },
    uiSchema: {
        project_land_use_id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Project Land Uses',
    description: 'Project land uses allow you to define the current usage of the land on a project.',
    table: 'project_land_uses',
    fields: ['project_land_use_id', 'description'],
    uniqueKey: 'project_land_use_id',
    columns: [
        {Header: 'ID', accessor: 'project_land_use_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'}
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ProjectLandUses extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(CAN_CREATE_PROJECT_LAND_USES)}
                canEdit={checkPermission(CAN_EDIT_PROJECT_LAND_USES)}
            />
        )
    }
}

export default ProjectLandUses